import { imagesArch } from "./imagesArch.js";
import { imagesBat } from "./imagesBat.js";
import { imagesDev } from "./imagesDev.js";
import { imagesServices } from "./imagesServices.js";

export const ro = {
  home: "/",
  locale: "ro",
  localeNav: "/ro",
  archNav: "arhitectura",
  servicesNav: "servicii",
  batNav: "constructie",
  devNav: "programare",
  archTitle: "Arhitectură",
  archTitle2: "Proiectele Mele de Arhitectură",
  batTitle: "Construcţie",
  batTitle2: "Realizările Mele",
  devTitle2: "Programarea de aplicații pentru uz personal",
  batTitle3:
    "Lucrările realizate în mare parte singur, fie sub supravegherea unui ucenic.",
  batTitle4:
    "Un adevărat profesionist este capabil să realizeze opere de artă, echipat cu o serie de unelte și câteva scule electrice.",
  servicesTitle: "Servicii",
  devTitle: "Programare web",
  devTitleNav: "Programare",
  comments: "Comentarii",
  iLike: "Îmi place",
  comment: "Comentează",
  share: "Distribuie",
  discoverProject: "Descoperă proiectul...",
  footer_p1: "Boogysh. Toate drepturile rezervate.",
  footer_p2: "Actualizat:",
  identity: "Identitate",
  lastName: "Nume",
  firstName: "Prenume",
  birthDay: "Ziua de naștere",
  birthPlace: "Locul de naștere",
  countryOfBirth: "Țara de naștere",
  country: "R. Moldova",
  nationalities: "Naționalități",
  nationalities_val: "Moldovenească și Română",
  ssNumber: "Număr de S.S.",
  adress: "Adresă",
  tel: "Telefon",
  email: "E-mail",
  civilStatus: "Stare civilă",
  civilStatus_val: "Căsătorit, doi copii.",
  studies: "Studii și diplome",
  school: "Școala generală MERENI",
  highSchool: "Liceul Republican Universitar Real, Profil Fizică-Matematică",
  bac: "Diplomă de bacalaureat",
  college:
    "Universitatea Tehnică a Moldovei, Facultatea de Urbanism și Arhitectură. Specialitatea: Inginerie urbană",
  master: "Master: Ingineria construcțiilor civile",
  master_stopped:
    "Întrerupt, profilul nu corespundea programului dorit, prea îndepărtat de Arhitectură",
  archicad_3dsMax: "Formațiune AUTOCAD, ARCHICAD, 3DS MAX.",
  devWeb: "Programator web, Openclassrooms",
  devWeb_val: "Diplomă de nivel 5 (bac +2)",
  experience: "Experiența",
  internship_1: "Stagiu de proiectare “IGC CONSTRUCT”",
  internship_2: "Stagiu pentru prepararea diplomei “IGC CONSTRUCT”",
  apprenticeship: "Ucenicie “IGC CONSTRUCT”",
  armanda:
    "Activitate multifuncțională nesalariată: Societatea “Armanda” 75012 Paris",
  armanda_2: "Gerant : Societatea “Armanda” 75012 Paris",
  catalan:
    "Activitate nesalariată, multi-specializată compania “Catalan Building”.",
  heres: "Compania “Hères Construction”",

  heres_val: "Șef de echipă, Șef pe mai multe echipe, Șef de șantier",
  dev: "Developer de aplicații - JavaScript React",
  dev_info: "Programare de aplicații pentru uz personal",
  renovation: "Renovarea caselor individuale",
  characteristics: "Caracteristici",
  characteristics_val:
    "Responsabilitate, Angajament, Punctualitate, Sociabilitate, Capacitate de a lucra cu clienții pentru a găsi o soluție individuală. Abilitatea de a lucra în echipă, rapid și eficient. Abilitate de a evalua situațiile, de a depăși obstacolele și de a lua măsurile adecvate (soluții) care se potrivesc. Abilitatea și dorința de a de a învăța rapid și eficient, domenii noi.",
  software: "Programe",
  advenced: "avansat",
  medium: "mediu",
  basic: "baza",
  dev_Technologies: "Tehnologiile de programare",
  install: "Instalare și întreținere",
  install_val: "WINDOWS, software și echipamente de birou.",
  languages: "Limbi străine",
  rom_mold: "Română/Moldovenească",
  french: "Franceza",
  native: "nativ",
  russian: "Rusa",
  english: "Engleza",
  writtenExpression: "exprimare scrisă (codul și comentariul în limba engleză)",
  writtenComprehension:
    "înțelegere scrisă (intermediară), înțelegere orală (intermediară), exprimare orală (începător)",
  driver_sLicense: "Permis de conducere",
  driverCategory: "Categoria B",
  download: "Descărcați",
  cardArch: [
    {
      id: "pr3-stade",
      title: "Centru de antrenament destinat forţelor de ordine",
      description:
        "Este un proiect destinat forțelor de ordine, dotat cu un teren de fotbal pentru 2300 de spectatori, un teren de volei, un teren de baschet, o piscină de 25 de metri, un teren de tenis, mai multe săli de box și de luptă, o sală de fitness etc.",
      info: [
        "Stadion: 2600 de spectatori.",
        "Spații: Baschet, Volei, Tenis, Box, Tir, Paintball, Fitness.",
        "Bazin de înot: 25m, 6 benzi.",
        "Odihnă: Saună, Terapie, Restaurant.",
        "Parcare: 360 de mașini.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr3-stade"].cover,
      pictures: imagesArch["pr3-stade"].pictures,
    },
    {
      id: "pr-maison-perso",
      title: "Casă individuală v-2024",
      description:
        "Casă pentru o familie cu 3-4 copii. Fotografiile sunt randări realizate cu 3D'S MAX + V-ray.",
      info: [
        "Casă din piatră.",
        "Pentru o familie de 5-6 persoane.",
        "Parter: living, sufragerie, bucătărie, un dormitor",
        "Parter: bloc sanitar, spălătorie și garaj",
        "Etaj: 3 dormitoare și bloc sanitar. ",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr-maison-perso"].cover,
      pictures: imagesArch["pr-maison-perso"].pictures,
    },
    {
      id: "pr1-maison",
      title: "Casă individuală P+S (parter + mansardă).",
      description:
        "Casă pentru o familie cu 3-4 copii. Fotografiile sunt randări realizate cu 3D'S MAX + V-ray.",
      info: [
        "Casă din blocuri de calcar.",
        "Pentru o familie formată din 5 - 6 persoane.",
        "Subsol: sală de sport și depozit.",
        "Parter: bucătărie, sală de mese, sufragerie, living, birou, bloc sanitar.",
        "Etaj: 4 dormitoare și bloc sanitar.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr1-maison"].cover,
      pictures: imagesArch["pr1-maison"].pictures,
    },
    {
      id: "pr2-maison",
      title: "Casă, inspirată dintr-un basm",
      description:
        "Această casă, cu trăsăturile sale neobișnuite, este încă destul de bine cunoscută. Cel mai dificil lucru este să sistematizezi spațiul pentru a-l transforma într-o locuință locuibilă.",
      info: [
        "Casă din blocuri de calcar.",
        "Pentru o familie formată din 4 - 5 persoane.",
        "Proiect cunoscut, adaptat la necesităţi cotidiene.",
        "Parter: bucătărie, sală de mese, living, WC.",
        "Etaj: 3 dormitoare, baie.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr2-maison"].cover,
      pictures: imagesArch["pr2-maison"].pictures,
    },
    {
      id: "pr3A-maison",
      title: "Casă individuală v-2023",
      description: "Projet personnel",
      info: [
        "Casă din piatră sau din blocuri cu gauri.",
        "Pentru o familie de 5-6 persoane.",
        "Parter: living, sufragerie, bucătărie, WC, baie",
        "Etaj: 3 dormitoare și bloc sanitar. ",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr3A-maison"].cover,
      pictures: imagesArch["pr3A-maison"].pictures,
    },
    {
      id: "pr4-cinema",
      title: "Boogysh Cinema",
      description:
        "Proiectul Boogysh Cinema este o soluție la probleme precum: fizica sunetului si calculul vizibilității, respectînd regulile de artă.",
      info: [
        "Sală de cinema, 24m lungime, 5 sectoare.",
        "Capacitate 528 de locuri.",
        "Calculul vizibilității, asigurat.",
        "Restaurante.",
        "Săli pentru administraţie.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr4-cinema"].cover,
      pictures: imagesArch["pr4-cinema"].pictures,
    },
    {
      id: "pr5-reconstruction",
      title: "Reconstrucția unei clădiri cu 4 etaje",
      description:
        "Consolidarea fundațiilor pentru a adăuga un nivel in plus mansarda.",
      info: [
        "Existent: Clădire cu 4 etaje, parter + 3 etaje",
        "Adăugarea unui etaj suplimentar și a unei mansarde.",
        "Calcule pentru fiecare tip de fundație.",
        "Consolidarea fundației pe sectoare de 3 m.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr5-reconstruction"].cover,
      pictures: imagesArch["pr5-reconstruction"].pictures,
    },
    {
      id: "pr6-urbanime",
      title: "Plan de urbanism",
      description:
        "Planul urbanistic detaliat al unui cartier pentru 5000 de locuitori.",
      info: [
        "Cartier pentru 5000 de locuitori.",
        "O grădiniță.",
        "Zone amenajate: Pentru copii cu vârste cuprinse între 3 și 7 ani.",
        "Zone amenajate: Pentru copii cu vârste cuprinse între 7 și 12 ani.",
        "Zone verzi.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr6-urbanime"].cover,
      pictures: imagesArch["pr6-urbanime"].pictures,
    },
    {
      id: "pr7-sistematisation-verticale",
      title: "Sistematizare verticală",
      description:
        "Sistematizarea verticală a unui cartier cu artera de transport adiacentă.",
      info: [
        "Identificarea curbelor de nivel pe plan.",
        "În funcție de curbele de nivel,se planifice o zonă cu clădiri și să se proiecteze o intersecție alungită de tip treflă.",
        "Determinarea cotei '0' al fiecărei clădiri.",
        "Prezintarea secțiunei transversale a șoselei.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr7-sistematisation-verticale"].cover,
      pictures: imagesArch["pr7-sistematisation-verticale"].pictures,
    },
  ],
  cardBat: [
    {
      id: "pr1-terasse",
      title: "Construirea unei terase din travertin și renovarea piscinei.",
      description: undefined,
      info: [
        "Realizarea unei șape de la 6 până la 12 cm.",
        "Instalarea placilor de travertin, 2 cm grosime, cu un model din 4 piese.",
        "Instalarea bordurelor de piscină, grosime de 5 cm.",
        "Piscină - instalarea placilor de mozaic 4,5 cm x 4,5 cm, adertant epoxidic.",
        "Aplicarea a două straturi de protecție pe piatră.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["pr1-terasse"].cover,
      pictures: imagesBat["pr1-terasse"].pictures,
    },
    {
      id: "renovation_totale",
      title: "Renovarea totală a unui apartament",
      description: undefined,
      info: [
        "Demolarea și evacuarea deșeurilor.",
        "Crearea pereţilor despărţitori din rigips.",
        "Instalarea de tâmplărie.",
        "Electricitate și instalații sanitare.",
        "Tencuiala și vopsirea.",
        "Șapa lichidă și încălzire electrică prin pardoseală.",
        "Gresie și faianţa în bucătărie și băi.",
        "Instalare lipită de parchet masiv în dormitoare.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["renovation_totale"].cover,
      pictures: imagesBat["renovation_totale"].pictures,
    },
    {
      id: "renovation_maison",
      title: "Renovarea unei case",
      description: undefined,
      info: [
        "Adaptarea la standarde a sistemului electric",
        "Tencuieli și vopsea",
        "Nivelarea pardoselii",
        "Montarea parchetului flotant la parter, compatibil cu încăperile umede",
        "Proiectarea și instalarea mobilierului de bucătărie IKEA",
        "Montarea parchetului flotant în camerele de la etaj",
        "Montarea gresiei în toalete și băi",
        "Înlocuire sistem VMC cu simplu flux",
        "Modificarea instalațiilor sanitare",
        "Balon nou pentru apă caldă",
        "Turnarea unei plăci de 12 cm grosime pe terasă",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["renovation_maison"].cover,
      pictures: imagesBat["renovation_maison"].pictures,
    },
    {
      id: "consolidation_maison",
      title: "Consolidarea fundațiilor",
      description: undefined,
      info: [
        "Săpături de-a lungul casei",
        "Săpături sub fundații",
        "Armarea ansamblului",
        "Turnarea betonului",
        "Aplicarea produsului de etanșare în două straturi",
        "Umplerea cu pământ",
        "Umplere cu pământ vegetal",
        "Reconstituirea gazonului",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["consolidation_maison"].cover,
      pictures: imagesBat["consolidation_maison"].pictures,
    },
    {
      id: "ouvertures",
      title: "Creaarea deschiderilor",
      description: undefined,
      info: [
        "Calcul al greutaţii transmise de la pereți, planșeu și acoperiș.",
        "Calcul și dimensionarea profilurilor din metal.",
        "Realizarea grinzilor în două etape.",
        "Construcția jambajelor din beton armat.",
        "Finalizarea deschiderii și îndepărtarea molozului.",
        "Realizarea unui suport sau prag din beton armat.",
        "Montarea tâmplăriei în conformitate cu DTU.",
        "Tencuiala și finisarea tablourilor.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["ouvertures"].cover,
      pictures: imagesBat["ouvertures"].pictures,
    },
    {
      id: "extension",
      title: "Construcția unei extinderi. Lucrări structurale",
      description: undefined,
      info: [
        "Realizarea unor fundații din beton armat cu adâncimea de 1,2 m.",
        "Planșeu parter cu plăci de polistiren și beton armat.",
        "Ridicarea pereților din blocuri de ciment de 20 cm.",
        "Fațadă construită din zidărie tradițională.",
        "Șarpanta cu racorduri corespunzatoare.",
        "Centura și coloane din beton armat.",
        "Acoperișul și lucarna sunt acoperite cu țiglă plată.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["extension"].cover,
      pictures: imagesBat["extension"].pictures,
    },
    {
      id: "isolation-placo",
      title: "Izolația pereților exteriori",
      description: undefined,
      info: [
        "Structură realizată cu traverse și montanți R48 și M48.",
        "Vată minerală GR32 cu o grosime de 120 mm.",
        "Membrană de etanșare.",
        "Placo BA13 normal/hidro/fonic/rezistent la foc.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["isolation-placo"].cover,
      pictures: imagesBat["isolation-placo"].pictures,
    },
    {
      id: "assainissement",
      title: "Canalizare și drenaj",
      description: undefined,
      info: [
        "Șanțuri cu o pantă de 2 cm la fiecare metru.",
        "Încleierea țevilor din PVC cu diametrul de 100 mm pentru fiecare scurgere.",
        "Racordarea la exteriorul casei, într-o gură de vizitare.",
        "Instalarea unei guri de vizitare 40x40 cu tampon de beton asociat.",
        "Sistem de drenaj cu 5 lungimi și o suprafață de 100 mp.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["assainissement"].cover,
      pictures: imagesBat["assainissement"].pictures,
    },
  ],
  cardDev: [
    {
      id: "pr12-fiche-eye",
      title: "Fiche-eye",
      urlProject: "https://fich-eye.vercel.app/",
      info: [
        "Crearea unui site pentru fotografi",
        "Liker imaginile folosind local storage",
        "Crearea unui slider",
        "Sortare  fotografiilor după popularitate, dată sau titlu",
        "Completarea și validarea formularului de contact",
        "Trimiterea mesajului către baza de date mongoDB",
      ],
      technos: ["html", "css", "js", "node", "mongoDB"],
      cover: imagesDev["pr12-fiche-eye"].cover,
      pictures: imagesDev["pr12-fiche-eye"].pictures,
    },
    {
      id: "pr11-moteur-recherche",
      title: "Crearea unui motor de căutare",
     urlProject: "https://les-petits-plat.vercel.app/",
      info: [
        "Crearea un motor de căutare cu două axe",
        "Crearea tagurilor pentru fiecare valoare căutată",
        "Căutare în Ingrediente, Aparate și ustensile",
        "Afișarea intersecției rezultatului căutării",
        "Afișarea unui mesaj personalizat pentru un rezultat nul",
      ],
      technos: ["html", "css", "js"],
      cover: imagesDev["pr11-moteur-recherche"].cover,
      pictures: imagesDev["pr11-moteur-recherche"].pictures,
    },
    {
      id: "pr10-social-media",
      title: "Crearea unei aplicații web tip rețea socială",
      urlProject: "https://sm-boogysh.vercel.app/",
      info: [
        "Utilizarea redux și react-redux, MongoDB și S3-AWS.",
        "Vedeți vizitatorii paginii utilizatorului.",
        "Dark-mode și butonul de căutare pentru utilizatorii înregistrați.",
        "Backend pentru a gestiona cererile GET, POST, PATCH, DELETE",
        "Înregistrarea și ștergerea fișierelor pe S3 și a URL-urilor pe MongoDB.",
        "Vizualizarea aplicației online cu Vercel.",
      ],
      technos: ["react", "tailwind", "redux", "node", "mongoDB", "aws"],
      cover: imagesDev["pr10-social-media"].cover,
      pictures: imagesDev["pr10-social-media"].pictures,
    },
    {
      id: "pr9-netflix-youtube",
      title: "Créez une application type netflix",
      urlProject: "https://boogysh-flix.vercel.app",
      info: [
        "Utilizarea redux și react-redux, MongoDB.",
        "Backend pentru a gestiona cererile GET, POST, PATCH, DELETE",
        "Integrarea themoviedb-api și youtube-api.",
        "Salvarea filmelor la favorite.",
        "Generarea și vizualizarea dinamică a trailerului filmului",
        "Vizualizarea aplicației online cu Vercel.",
      ],
      technos: [
        "react",
        "tailwind",
        "redux",
        "node",
        "mongoDB",
        "themoviedb",
        "youtube",
      ],
      cover: imagesDev["pr9-netflix-youtube"].cover,
      pictures: imagesDev["pr9-netflix-youtube"].pictures,
    },
    {
      id: "pr8-castle",
      title: "Crearea unei aplicații web cu elemente de e-comerț",
      urlProject: "https://castle-boogysh.vercel.app/",
      info: [
        "Utilizarea redux și react-redux.",
        "Crearea unui backend pentru a gestiona cererile GET, POST.",
        "Utilizarea MongoDB și mongoose.",
        "Trimiterea mesajelor și comenzilor către baza de date.",
        "Căutarea comenzilor după e-mail sau după numărul de comandă.",
        "Vizualizarea aplicaţiei online cu Vercel.",
      ],
      technos: ["react", "css", "redux", "node", "mongoDB"],
      cover: imagesDev["pr8-castle"].cover,
      pictures: imagesDev["pr8-castle"].pictures,
    },
    {
      id: "pr7-kasa",
      title: "Crearea unei aplicații web pentru închiriere de imobile cu React",
      urlProject: "https://boogysh.github.io/kasa/",
      info: [
        "Descompunerea în componente modulare și reutilizabile.",
        "Configurer la navigation entre les pages avec React Router.",
        "Utilizarea proprietăţilor între componente.",
        "Utilizarea statului în componente, dacă este necesar.",
        "Managementul evenimentelor.",
        "Pagina 404 este returnată pentru fiecare rută inexistentă sau există o greșeală în URL.",
      ],
      technos: ["react", "css"],
      cover: imagesDev["pr7-kasa"].cover,
      pictures: imagesDev["pr7-kasa"].pictures,
    },
    {
      id: "pr6-api-piquante",
      title:
        "Programarea unui API securizat pentru o aplicație de evaluare a alimentelor",
      urlProject: "https://github.com/boogysh/piquante",
      info: [
        "Toate rutele au o autorizație tipică: Purtător <token>.",
        "Parola utilizatorului este criptată.",
        "Adresa de e-mail din baza de date MongoDB este unică (mongoose-unique-validator).",
        "Se verifică dacă utilizatorul este autorizat să modifice sau să șteargă un sos.",
        "Colectarea erorilor din baza de date, prin mesaje de eroare personalizate.",
      ],
      technos: ["node", "mongoDB"],
      cover: imagesDev["pr6-api-piquante"].cover,
      pictures: imagesDev["pr6-api-piquante"].pictures,
    },
    {
      id: "pr5-eCommerce",
      title: "Construiți un site de e-comerț în JavaScript",
      urlProject: "https://github.com/boogysh/kanap",
      info: [
        "Gestionarea evenimentelor JavaScript.",
        "Interacțiunea cu un serviciu web cu JavaScript.",
        "Validarea datelor din surse externe.",
        "Creați un plan de testare pentru o aplicație.",
      ],
      technos: ["js"],
      cover: imagesDev["pr5-eCommerce"].cover,
      pictures: imagesDev["pr5-eCommerce"].pictures,
    },
    {
      id: "pr4-SEO",
      title: "Optimizarea unui site web existent:",
      urlProject: "https://boogysh.github.io/La-panthere/",
      urlExistent: "https://boogysh.github.io/la-panthere_initial/",
      info: [
        "Utilizarea unui domen personalizat.",
        "Optimizarea dimensiunii și a vitezei unui site web.",
        "Efectuarea de cercetări cu privire la cele mai bune practici în dezvoltarea web.",
        "Scrieți cod HTML și CSS ușor de întreținut.",
        "Asigurarea accesibilității unui site web.",
        "Optimizarea referențierii unui site web.",
      ],
      technos: ["html", "css", "js"],
      cover: imagesDev["pr4-SEO"].cover,
      pictures: imagesDev["pr4-SEO"].pictures,
    },
    {
      id: "pr3-ohmyfood",
      title: "Faceți o pagină web dinamică cu animații CSS",
      urlProject: "https://boogysh.github.io/OCR_PR3/",
      info: [
        "Utilizați un sistem de control al versiunilor pentru urmărirea și găzduirea proiectelor.",
        "Configurarea mediului frontend.",
        "Asigurarea coerenței grafice a unui site web.",
        "Crearea unei structuri de navigare pentru un site web.",
        "Implementarea efectelor grafice avansate CSS.",
      ],
      technos: ["html", "sass"],
      cover: imagesDev["pr3-ohmyfood"].cover,
      pictures: imagesDev["pr3-ohmyfood"].pictures,
    },
    {
      id: "pr2-booki",
      title: "Transformați o machetă într-un site web cu html și css",
      urlProject: "https://boogysh.github.io/booki/",
      info: [
        "Decuparea machetei.",
        "Crearea paginii de cazări.",
        "Crearea paginii de activități.",
        "Utilizați tag-uri semantice.",
        "Realizarea părții receptive.",
        "Validarea codului cu W3C.",
      ],
      technos: ["html", "css"],
      cover: imagesDev["pr2-booki"].cover,
      pictures: imagesDev["pr2-booki"].pictures,
    },
  ],
  cardServices: [
    {
      id: "second_oeuvres",
      title: "Lucrări de finisare",
      description: undefined,
      info: [
        "Realizarea șapelor și a raclajelor",
        "Izolare termică și fonică",
        "Montarea tâmplăriei interioare",
        "Pereți despărțitori din Placostil și plăci de gips",
        "Tencuieli și vopsea",
        "Parchet lipit și flotant",
        "Etanșare, gresie și faianță și fisuri în pereți",
        "Racordarea la electricitate si instalatii sanitare",
        "Asamblarea și instalarea mobilierului",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesServices["second_oeuvres"].cover,
      pictures: imagesServices["second_oeuvres"].pictures,
    },
    {
      id: "gros_oeuvres",
      title: "Lucrări majore",
      description: undefined,
      info: [
        "Crearea deschiderilor",
        "Montarea elementelor de tâmplărie exterioară",
        "Realizarea unor lucrări mici de terasament cu acces dificil pentru utilaje",
        "Realizarea dalelor sau teraselor cu grosimea de 12 cm",
        "Construirea zidurilor",
        "Racordarea canalizării în cadrul renovării",
        "Consolidarea fundațiilor",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesServices["gros_oeuvres"].cover,
      pictures: imagesServices["gros_oeuvres"].pictures,
    },
  ],
};
